import { render, staticRenderFns } from "./MultiChoice.vue?vue&type=template&id=33f58b93&scoped=true"
import script from "./MultiChoice.vue?vue&type=script&lang=js"
export * from "./MultiChoice.vue?vue&type=script&lang=js"
import style0 from "./MultiChoice.vue?vue&type=style&index=0&id=33f58b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f58b93",
  null
  
)

export default component.exports